// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicNotPaidStatusCard } from "./plasmic/collect_wise_draft/PlasmicNotPaidStatusCard";

function NotPaidStatusCard_(props, ref) {
  // Use PlasmicNotPaidStatusCard to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicNotPaidStatusCard are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all NotPaidStatusCardProps here, but feel free
  // to do whatever works for you.
  return <PlasmicNotPaidStatusCard root={{ ref }} {...props} />;
}

const NotPaidStatusCard = React.forwardRef(NotPaidStatusCard_);

export default NotPaidStatusCard;
